import React from 'react';

function CallToAction() {
  return (
    <section id="download" className="cta-section">
      <div className="container cta-content">
        <h2>Ready to Start Growing?</h2>
        <p>Download Homesteadr today and take the first step towards a fresher, healthier, and more sustainable food future for you and your community.</p>
        <div style={{ marginTop: '24px' }}>
          <a
            href="https://app.homesteadr.ai"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justify: 'center',
              backgroundColor: '#2D5A27',
              color: '#FFFFFF',
              borderRadius: '8px',
              padding: '14px 28px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              textDecoration: 'none',
              boxShadow: '0 4px 12px rgba(45,90,39,0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#1E3E1B';
              e.currentTarget.style.transform = 'scale(1.03)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#2D5A27';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Launch Web App 🌱
          </a>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
